import { Drawer, Popover } from '@mui/material'
import { useContext } from 'react'
import { ActionStartingPointContext } from '../PlayListPopOverStartingPointProvider/context'
import { PlayListVideoWhichNextActionContent } from './PlayListVideoWhichNextActionContent'
import { PlayListVideoWhichNextActionProps } from './type'

export const PlayListVideoWhichNextAction = ({
  isOpen,
  onClose,
  startAddVideoToPlayList,
  startDeletePlayListVideo,
}: PlayListVideoWhichNextActionProps) => {
  const { startPointElement } = useContext(ActionStartingPointContext)

  return (
    <>
      <Drawer
        anchor='bottom'
        open={isOpen}
        onClose={onClose}
        sx={{ display: { xs: 'block', sm: 'none' } }}
      >
        <PlayListVideoWhichNextActionContent
          onClose={onClose}
          startAddVideoToPlayList={startAddVideoToPlayList}
          startDeletePlayListVideo={startDeletePlayListVideo}
        />
      </Drawer>
      <Popover
        open={isOpen}
        anchorEl={startPointElement}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{ display: { xs: 'none', sm: 'block' } }}
      >
        <PlayListVideoWhichNextActionContent
          onClose={onClose}
          startAddVideoToPlayList={startAddVideoToPlayList}
          startDeletePlayListVideo={startDeletePlayListVideo}
        />
      </Popover>
    </>
  )
}
